import TinyCommons from "@tiny/tiny-commons";
import { useNavigate } from "react-router-dom";
import { authStorage } from "@tiny/utils";

/**
 * TinyAlbert's customer-history page — the shared @tiny/tiny-commons UI (same
 * module email uses) rendered with einstein's config. Mounted at
 * /main/customer-history/:customerEmail; TinyCommons reads the email from the URL.
 */
function decodeAccountId(): string {
  try {
    const token = authStorage.getAccessToken();
    if (!token) return "";
    return JSON.parse(atob(token.split(".")[1]))?.accountId ?? "";
  } catch {
    return "";
  }
}

function CustomerHistory() {
  const navigate = useNavigate();
  const config = {
    appName: "tinyAlbert" as const,
    baseUrl: import.meta.env.VITE_APP_API_URL || "",
    navigateTo: (path: string) => navigate(path),
    accountId: decodeAccountId(),
    // TinyAlbert is a Shopify app.
    shopifyIntegration: true,
    currency: "USD",
    pageName: "customerHistory",
  };
  return <TinyCommons config={config} />;
}

export default CustomerHistory;
